import axios from 'axios';
import { BASE_URL } from '../common/constants';

export const SHUTDOWN_ADMIN_EMAILS = [
  'vikasgarg.wd@gmail.com',
  'sam@Lifetab.co',
  'sam@talkoftoday.com',
];

export const apiUrl = (path) => `${BASE_URL}${String(path).replace(/^\//, '')}`;

const authHeaders = () => {
  const headers = {
    'Cache-Control': 'no-cache',
    language: 'en',
    utcoffset: String(new Date().getTimezoneOffset()),
  };
  const token = typeof window !== 'undefined' ? window.localStorage.getItem('token') : null;
  if (token) {
    headers.authorization = token;
  }
  return headers;
};

export const fetchShutdownBanner = () =>
  axios.get('/api/shutdown-banner');

export const downloadUserExport = async (exportPath = '/api/export') => {
  const token = typeof window !== 'undefined' ? window.localStorage.getItem('token') : null;
  if (!token) {
    throw new Error('You must be logged in to download your data.');
  }

  const res = await fetch(apiUrl(exportPath), {
    method: 'GET',
    headers: authHeaders(),
  });

  if (!res.ok) {
    let message = 'Export failed. Please try again.';
    try {
      const err = await res.json();
      message = err?.message || err?.responseData?.message || message;
    } catch (_) {}
    throw new Error(message);
  }

  const blob = await res.blob();
  const filename =
    res.headers.get('Content-Disposition')?.match(/filename="(.+)"/)?.[1] ||
    'lifetab-export.json';
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
};

export const fetchRecipientsPreview = () =>
  axios.get('/api/shutdown-email/recipients-preview');

export const startShutdownCampaign = (body = {}) =>
  axios.post('/api/shutdown-email/start-campaign', body);

export const fetchCampaignStatus = (campaignId) =>
  axios.get(`/api/shutdown-email/campaigns/${campaignId}`);

export const isShutdownAdmin = (email) =>
  email && SHUTDOWN_ADMIN_EMAILS.some((e) => e.toLowerCase() === email.toLowerCase());
